import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import cart from './cart'
import productlist from './productlist'
import checkout from './checkout'
import location from './location'
import notification from './notification'
import error from './error'
import additionalproducts from './additionalproducts'
import account from './account'
import migration from './migration'
import reservation from './reservation'
import childproducts from './childproducts'
import dialog from './dialog'
import loader from './loader'
import planzer from './planzer'
//import eventHub from './eventhub'
import { config } from '@/config'

Vue.use(Vuex)
//Vue.prototype.$eventHub = eventHub

export default new Vuex.Store({
	state: {
		brands: [
			{
				code: config.BRAND,
			}
		],
	},
	getters,
	actions,
	mutations,
	modules: {
		cart,
		productlist,
		checkout,
		location,
		error,
		notification,
		additionalproducts,
		account,
		migration,
		reservation,
		childproducts,
		dialog,
		loader,
		planzer,
	}
})
